import { render, staticRenderFns } from "./home.view.vue?vue&type=template&id=496876d4&scoped=true&"
import script from "./home.view.vue?vue&type=script&lang=ts&"
export * from "./home.view.vue?vue&type=script&lang=ts&"
import style0 from "./home.view.vue?vue&type=style&index=0&id=496876d4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496876d4",
  null
  
)

export default component.exports